<template>
  <v-timeline align-top dense>
    <v-timeline-item v-for="(item , itemIndex) in entries"
                     :key="'timeline_' + itemIndex"
                     class="pa-0 pt-6"
                     color="fin-color-primary-dark"
                     small>
      <v-row :dense="$vuetify.breakpoint.xs">
        <v-col cols="12" sm="auto" v-if="item.date">
          <slot name="time">
            <span class="time">{{ item.date | date }}</span>
          </slot>
        </v-col>
        <v-col class="content-col">
          <slot name="content">
            <fin-lexicon-text v-if="item.title" :text="item.title" auto-solve class="content-title"/>
            <br/>
            <fin-lexicon-text v-if="item.text" :text="item.text" auto-solve class="content-text"/>
          </slot>
        </v-col>
      </v-row>
    </v-timeline-item>
  </v-timeline>
</template>


<script>

import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {
  name: "FinTimeLine",
  components: {FinLexiconText},
  props: {
    entries: {
      /*** Arrays of entries containing the fields date, title and text */
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>

.time, .content-title {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.content-text {
  line-height: 1.2;
}

::v-deep .v-timeline-item__dot {
  z-index: 1;
}

</style>
